import { Collo } from './../Models/Collo';
import {AfterViewChecked, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-colli',
  templateUrl: './colli.component.html',
  styleUrls:['./colli.component.scss']
})
export class ColliComponent implements OnInit, AfterViewChecked {
  @Input()
  myProp: Collo[];
  // Use in your component to write an updated value back out to the parent  // Output prop name must be Input prop name + 'Change'
  @Output()
  myPropChange = new EventEmitter<Collo[]>();
  @Input() isModifyDisabled: boolean = false;
  @Output() isModifyDisabledChange = new EventEmitter<boolean>();
  totalept: number = 0;
  totalepv: number = 0;
  totalepv333: number = 0;
  totalekg: number = 0;
  constructor(private toastService: ToastrService) { }

  ngAfterViewChecked() {
    this.counttotalept();
  }

  ngOnInit() {
    this.myProp.forEach(element=>{
      element.modifica = false;
      this.peso_equivalente(element);
    })

  }
  add() {
    if (!this.myProp || this.myProp.length >= 10) {
      this.toastService.error("Hai raggiunto il numero massimo di colli per questa spedizione", "Errore");
      return;
    }
    this.myProp.push({
      kg: 1,
      h: 10,
      l: 10,
      p: 10,
      modifica: true
    })
    this.myPropChange.emit(this.myProp);
  }
  counttotalept(){
    this.totalept = 0;
    this.totalepv = 0;
    this.totalepv333 = 0;
    this.totalekg = 0;
    this.myProp.forEach(element=> {
      if(element.pt && element.pt > 0)
      this.totalept = this.totalept + parseFloat(element.pt.toString());
      if(element.pe && element.pe > 0)
        this.totalepv = this.totalepv + parseFloat(element.pe.toString());
      this.totalepv333 = this.totalepv333 + ((element.h * element.l * element.p)/3333);
      if(element.kg && element.kg > 0)
        this.totalekg = this.totalekg + parseFloat(element.kg.toString());
    })
  }
  peso_equivalente(collo: Collo){
    collo.pe = (collo.h * collo.l * collo.p)/4000;
    collo.pe333 = (collo.h * collo.l * collo.p)/3333;
    collo.pt = this.tassabile(collo);
    // /5000
  }
  tassabile(collo: Collo): number{
    if(collo.pe > collo.kg)
      return collo.pe
    else
      return collo.kg
  }

  edit(item: Collo) {
    if (item.modifica) {
      if (item.kg < 0.01)
        this.toastService.warning("inserire il peso (peso minimo ammissibile 0.01 kg)", "Attenzione!!");
      else if (item.h < 0.1)
        this.toastService.warning("inserire l'altezza (altezza minima ammissibile 0.1 cm )", "Attenzione!!");
      else if (item.l < 1)
        this.toastService.warning("inserire la larghezza (altezza minima ammissibile 1 cm )", "Attenzione!!");
      else if (item.p < 1)
        this.toastService.warning("inserire la profondità (altezza minima ammissibile 1 cm )", "Attenzione!!");
      else{
        item.modifica = !item.modifica;
        this.peso_equivalente(item);
        this.counttotalept();
      }
    } else {
      item.modifica = !item.modifica;
    }

  }
  delete(item: Collo) {
    const idx: number = this.myProp.findIndex(x => x == item);
    if (idx > -1) {
      this.myProp.splice(idx, 1);
      this.myPropChange.emit(this.myProp);
      this.counttotalept();
    }
  }
}
